var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.listSubClassifiers.filter(
      (data) =>
        !_vm.searchSubClassifiers ||
        data.name.toLowerCase().includes(_vm.searchSubClassifiers.toLowerCase())
    )),function(link,key){return _c('div',{key:key},[_c('el-link',{attrs:{"type":"success"},on:{"click":function($event){return _vm.reLocate(link.id)}}},[_vm._v(" "+_vm._s(link.title)+" ")]),_c('el-divider')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }